import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { useMe } from "@crehana/auth";
import { useTranslation } from "@crehana/i18n";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Container } from "@crehana/ui";
import cn from "clsx";
import { MAIN_FOOTER_PAGE_KEY } from "./constants";
import localeEn from "./i18n/localeEn";
import localeEs from "./i18n/localeEs";
import localePt from "./i18n/localePt";
import BottomSection from "./sections/BottomSection";
import { jsx as _jsx } from "react/jsx-runtime";
var TRANSLATIONS = {
  es: /*#__PURE__*/_defineProperty({}, MAIN_FOOTER_PAGE_KEY, localeEs.es),
  pt: /*#__PURE__*/_defineProperty({}, MAIN_FOOTER_PAGE_KEY, localePt.pt),
  en: /*#__PURE__*/_defineProperty({}, MAIN_FOOTER_PAGE_KEY, localeEn.en)
};
var MainFooter = function MainFooter(_ref) {
  var isDark = _ref.isDark,
    className = _ref.className,
    _ref$ignoreBgTranspar = _ref.ignoreBgTransparent,
    ignoreBgTransparent = _ref$ignoreBgTranspar === void 0 ? false : _ref$ignoreBgTranspar,
    containerType = _ref.containerType,
    layouts = _ref.layouts,
    _ref$shouldHideAppsCo = _ref.shouldHideAppsColumn,
    shouldHideAppsColumn = _ref$shouldHideAppsCo === void 0 ? false : _ref$shouldHideAppsCo;
  var _useMe = useMe(),
    me = _useMe.me;
  var _useTranslation = useTranslation(),
    addResourceBundle = _useTranslation.addResourceBundle;
  var shouldHideCurrencySelector = typeof (layouts === null || layouts === void 0 ? void 0 : layouts.shouldHideCurrencySelector) === 'boolean' ? layouts.shouldHideCurrencySelector : !!(me !== null && me !== void 0 && me.isB2B);
  addResourceBundle(TRANSLATIONS);
  return /*#__PURE__*/_jsx("footer", {
    id: "main-footer",
    className: cn('tw-pt-3.2 sm:tw-pt-4.8 lg:tw-pt-6.4', {
      'bg-base-main-80': isDark,
      'tw-bg-transparent': !isDark && !ignoreBgTransparent
    }, className),
    children: /*#__PURE__*/_jsx(Container, {
      type: containerType,
      children: /*#__PURE__*/_jsx(BottomSection, {
        isDark: isDark,
        shouldHideCurrencySelector: shouldHideCurrencySelector,
        shouldHideAppsColumn: shouldHideAppsColumn
      })
    })
  });
};
export default MainFooter;